import { SensitivityAnalysisResult, UnitRateModelFeatureKey } from '@aloft/toolkit-shared';

import { createContext, useContext } from 'react';

type PropertyGridSensitivityContextValue = {
  sensitivityResult?: SensitivityAnalysisResult;
  sensitivityFeatureKey?: UnitRateModelFeatureKey;
};

export const PropertyGridSensitivityContext = createContext<PropertyGridSensitivityContextValue>(
  {},
);

export const useSensitivityContext = () => useContext(PropertyGridSensitivityContext);
